'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _automation = require('../../../utils/automation');

var _Button = require('../../Button');

var _Button2 = _interopRequireDefault(_Button);

var _styles = require('./styles.css');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Theirs.
var ModalFooter = function ModalFooter(_ref) {
  var onCancel = _ref.onCancel,
      primaryAction = _ref.primaryAction,
      secondaryAction = _ref.secondaryAction,
      supportingText = _ref.supportingText,
      title = _ref.title;

  var primaryButton = null;
  if (primaryAction && primaryAction.label) {
    primaryButton = _react2.default.createElement(_Button2.default, {
      text: primaryAction.label,
      type: 'primary',
      onClick: primaryAction.action,
      disabled: primaryAction.disabled,
      qaId: (0, _automation.id)('modal', 'footer', 'primary', 'button', title)
    });
  }

  var secondaryButton = null;
  if (secondaryAction && secondaryAction.label) {
    secondaryButton = _react2.default.createElement(_Button2.default, {
      text: secondaryAction.label,
      type: 'secondary',
      weight: secondaryAction.weight,
      onClick: secondaryAction.action,
      disabled: secondaryAction.disabled,
      qaId: (0, _automation.id)('modal', 'footer', 'secondary', 'button', title)
    });
  }

  var cancelButton = null;
  if (onCancel) {
    cancelButton = _react2.default.createElement(_Button2.default, {
      text: 'Cancel',
      type: 'secondary',
      weight: 'reduced',
      onClick: onCancel,
      qaId: (0, _automation.id)('modal', 'footer', 'cancel', 'button', title)
    });
  }

  return _react2.default.createElement(
    'div',
    { className: _styles2.default.modal__footer },
    _react2.default.createElement(
      'span',
      { className: _styles2.default.footer__text },
      supportingText
    ),
    cancelButton,
    secondaryButton,
    primaryButton
  );
};

// Ours.


var actionShape = _react.PropTypes.shape({
  label: _react.PropTypes.string,
  weight: _react.PropTypes.oneOf(['normal', 'reduced']),
  action: _react.PropTypes.func,
  disabled: _react.PropTypes.bool
});

var defaultActionProps = {
  disabled: false,
  weight: 'normal'
};

ModalFooter.defaultProps = {
  primaryAction: defaultActionProps,
  secondaryAction: defaultActionProps
};

ModalFooter.propTypes = {
  onCancel: _react.PropTypes.func,
  primaryAction: actionShape,
  secondaryAction: actionShape,
  supportingText: _react.PropTypes.string,
  title: _react.PropTypes.string
};

exports.default = ModalFooter;